import { Modal, Button } from "antd";
import { Convocatoria2 } from "../../../../../models/ConvocatoriasModel/convocatoria.model";
import moment, { now } from "moment";
import banner from "../../../../../assets/landing/bannerEvento.png"
import React, { useEffect, useState } from "react";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import ImageNotFound from "../../../../../assets/enmascarar-detail.png";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { es } from 'date-fns/locale';
import { format } from 'date-fns';

import Pdf from "../../../../../assets/pp/1PORTAFOLIO GENERAL ESTIMULOS PP CULTURA 28 abril 2025.pdf"
interface StateConvocatoria {
  convocatorias: Convocatoria2;
  visualizar: boolean;
  setVisualizar: any;
}
export const ModalVisualizarEvento: React.FC<StateConvocatoria> = (props: StateConvocatoria) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }
  const [loading, setLoading] = useState<boolean>(true);
  const [dataImg, setDataImg] = useState<any>();
  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        setLoading(false)
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  useEffect(() => {
    getImageConvocatoria();
  }, [props.convocatorias]);

  const fechaStr = props.convocatorias.fechas?.find(f => f.clave === "Apertura")?.valormax;
  const fecha = fechaStr ? new Date(fechaStr) : null;
  const hora = fecha?.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  const dia = fecha ? format(fecha, "EEEE d 'de' MMMM 'de' yyyy", { locale: es }) : '';
  const diaCapitalizado = dia.charAt(0).toUpperCase() + dia.slice(1);

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={1100}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="convocatoria-container">
      {/* Banner con imagen de fondo y evento */}
      <div
        className="banner"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="evento-categoria">
          <span>📌 {props.convocatorias?.area?.map((area) => `${area.text} `)}</span>
        </div>
        <img className="evento-imagen" src={dataImg ? dataImg : ImageNotFound} alt="Evento" />
        {/*<div className="redes-sociales">
          <a className="redes-sociales-icon" href="#"><AiFillFacebook /></a>
          <a className="redes-sociales-icon" href="#"><AiFillInstagram /></a>
          <a className="redes-sociales-icon" href="#"><AiFillYoutube  /></a>
        </div>*/}
      </div>
      <br />
      <div className="row justify-content-center">
        <div className="font-family-Montserrat-Bold text-center font-color-black" style={{fontSize:29}}>
            <strong>
              {props.convocatorias.nombre_convocatoria}
            </strong>
          </div>
      </div>
      {/* Contenido de 3 columnas */}
      <div className="columnas">
        {/* Columna 1 */}
        <div className="columna">
          <h3>📅 Fecha</h3>
          <br />
          <div className="text-center">
            <DatePicker
              selected={fecha}
              onChange={() => {}} // Evita cambios
              dateFormat="yyyy-MM-dd"
              inline
              calendarStartDay={0}
              locale={es}
              disabledKeyboardNavigation
              renderCustomHeader={() => null} // Oculta la navegación de meses
              dayClassName={(date) =>
                date.getTime() !== fecha.getTime() ? 'react-datepicker__day--disabled' : ''
              }
            />
          </div>
          {hora && (
            <div className="text-center">
              <p>
                {diaCapitalizado}
              </p>
            </div>
          )}
        </div>

        {/* Columna 2 */}
        <div className="columna">
          <h3>📍 Lugar</h3>
          <p>{props.convocatorias.objetivo}</p>
          <iframe
            src={props.convocatorias.descripcion_corta}
            title="Mapa"
            width="100%"
            height="150"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
          <div className="text-center">
            <button
              onClick={(e) => {
                  window.open(props.convocatorias.descripcion_corta, "_blank");
                }}
              >
              ¿CÓMO LLEGAR?
            </button>
          </div>
        </div>

        {/* Columna 3*/}
        <div className="columna">
          {/*
          <h3>💳 Ingreso</h3>
          <p>Boletería en Línea ${}</p>
          <div className="text-center">
            <button>COMPRAR</button>
          </div>
          <hr />
          */}
          <h4>🕒 Hora</h4>
          <p>{hora}</p>
          <hr />
          <h4>🏛️ Sala</h4>
          <ul>
            <li>{props.convocatorias.noparticipa}</li>
          </ul>
          <hr />
          <h4>🎨 Artista</h4>
          <ul>
            <li>{props.convocatorias.perfil_participante}</li>
          </ul>
        </div>
      </div>
    </div>
  </Modal>
  )
};
